// Approved copy, in rotation order. Adding or reordering lines shifts which line every day shows.
const WELCOME_TITLES = [
  'What can I take off your plate today?',
  'What shall we untangle today?',
  'Got something you\'d rather hand off?',
  'Point me at something tedious.',
  'What\'s been sitting on the list a little too long?',
  'Put me to work. What\'s first?',
  'Any loose ends I can tie up?',
  'Hand me the boring bits.',
  'What would make today a bit lighter?',
  'Let\'s knock something off the list.',
  'What can I chip away at for you?',
  'Where shall we start?',
];

const MS_PER_DAY = 86_400_000;

/**
 * The new-chat welcome line for the viewer's local calendar date. Keyed on the date alone so the popup
 * and full-screen agent always agree, and the line only changes overnight.
 */
export function welcomeTitleForDate(date: Date): string {

  // Date.UTC over the local year/month/day counts whole local days, so daylight saving never skips or repeats one.
  const localDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY;
  return WELCOME_TITLES[localDay % WELCOME_TITLES.length];
}
